import {ArrowRight} from '@nlabs/gothamjs/icons';
import {Link} from '@nlabs/gothamjs/router';

import {features} from '../../content/features.js';
import {primaryButton, secondaryButton} from '../../theme/classes.js';
import {CreativeModels} from '../CreativeModels/CreativeModels.js';
import {FeatureRow} from '../FeatureRow/FeatureRow.js';

import type {ReactElement} from 'react';

export const FeaturesPage = ({signedIn = false}: {readonly signedIn?: boolean}): ReactElement => (
  <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 sm:py-16">
    <header className="mb-8 max-w-3xl sm:mb-10">
      <p className="text-xs font-medium tracking-[.18em] text-sky-200 uppercase">Explore the studio</p>
      <h1 className="mt-5 text-5xl leading-[1.06] tracking-tight sm:text-7xl">Every feature.<br /><span className="text-violet-300">Room for every idea.</span></h1>
      <p className="mt-5 max-w-2xl text-sm leading-6 text-zinc-200">Your creative toolkit, at a glance. Select a row for details.</p>
      <p className="mt-2 text-xs leading-6 text-zinc-200">Projects, characters, continuity, and Elements are included free. AI generation uses paid credits.</p>
    </header>
    <CreativeModels />
    <section aria-label="Feature details" className="overflow-hidden rounded-2xl border border-white/10 bg-[#151419]/80">
      <div aria-hidden="true" className="hidden grid-cols-[32px_220px_minmax(0,1fr)_100px_16px] gap-4 border-b border-white/10 bg-white/3 px-6 py-3 text-[10px] font-medium tracking-wider text-zinc-200 uppercase md:grid"><span /><span>Feature</span><span>At a glance</span><span>Access</span><span /></div>
      {features.map((feature) => <FeatureRow feature={feature} key={feature.id} />)}
    </section>
    <section className="mt-14 rounded-3xl border border-violet-300/20 bg-violet-400/5 p-7 sm:mt-20 sm:p-10">
      <h2 className="text-3xl text-violet-200">Start with your story.</h2>
      <p className="mt-4 max-w-xl leading-7 text-zinc-200">Create your cast, develop your idea, and write the shots. Your free account gives your next project a place to begin.</p>
      <div className="mt-7 flex flex-wrap gap-3"><Link className={primaryButton} to={signedIn ? '/projects' : '/sign-up'}>{signedIn ? 'Open your studio' : 'Create a free account'} <ArrowRight size={16} /></Link><Link className={secondaryButton} to="/pricing">Explore plans</Link></div>
    </section>
  </div>
);
